import React from 'react';
import s from './PaymentBreakdown.scss';
import classnames from 'clsx';
import {useControllerProps} from '../../../../../../domain/controllers/ControllerContext';
import {useTranslation} from '@wix/yoshi-flow-editor';
import {TotalUpdateSkeleton} from '../SubTotals/TotalUpdateSkeleton';

export enum PaymentBreakdownDataHook {
  Root = 'PaymentBreakdown.Root',
  PayNowTitle = 'PaymentBreakdown.PayNowTitle',
  PayNowValue = 'PaymentBreakdown.PayNowValue',
  PayLaterTitle = 'PaymentBreakdown.PayLaterTitle',
  PayLaterValue = 'PaymentBreakdown.PayLaterValue',
  PayAfterFreeTrialTitle = 'PaymentBreakdown.PayAfterFreeTrialTitle',
  PayAfterFreeTrialValue = 'PaymentBreakdown.PayAfterFreeTrialValue',
}

export const PaymentBreakdown = () => {
  const {
    cartStore: {cartSummary, isSummaryUpdating},
    orderStore: {shouldDisplayPayNowPayLater},
  } = useControllerProps();
  const {t} = useTranslation();

  if (!shouldDisplayPayNowPayLater) {
    return null;
  }

  const payNow = cartSummary.paymentSummary.payNow;
  const payAfterFreeTrial = cartSummary.paymentSummary.payAfterFreeTrial;
  const payLater = cartSummary.paymentSummary.payLater;
  const hasFreeTrial = payAfterFreeTrial.convertedAmount > 0;
  const hasPayLater = payLater.convertedAmount > 0;

  return (
    <div data-hook={PaymentBreakdownDataHook.Root} className={classnames(s.topDivider, s.root)}>
      <dl>
        <dt>
          <span data-hook={PaymentBreakdownDataHook.PayNowTitle} className={s.payNow}>
            {t('cart.orderSummary.amountDueNow.label')}
          </span>
        </dt>
        <dd
          data-hook={PaymentBreakdownDataHook.PayNowValue}
          data-wix-paynow-value={PaymentBreakdownDataHook.PayNowValue}
          className={s.payNow}>
          {isSummaryUpdating ? <TotalUpdateSkeleton /> : payNow.formattedConvertedAmount}
        </dd>
      </dl>
      {hasFreeTrial && (
        <dl>
          <dt>
            <span data-hook={PaymentBreakdownDataHook.PayAfterFreeTrialTitle}>
              {t('cart.pricingPlans.afterFreeTrial.label')}
            </span>
          </dt>
          <dd
            data-hook={PaymentBreakdownDataHook.PayAfterFreeTrialValue}
            data-wix-paynow-value={PaymentBreakdownDataHook.PayAfterFreeTrialValue}>
            {isSummaryUpdating ? <TotalUpdateSkeleton /> : payAfterFreeTrial.formattedConvertedAmount}
          </dd>
        </dl>
      )}
      {hasPayLater && (
        <dl>
          <dt>
            <span data-hook={PaymentBreakdownDataHook.PayLaterTitle}>
              {t('cart.orderSummary.amountDueLater.label')}
            </span>
          </dt>
          <dd
            data-hook={PaymentBreakdownDataHook.PayLaterValue}
            data-wix-paylater-value={PaymentBreakdownDataHook.PayLaterValue}>
            {isSummaryUpdating ? <TotalUpdateSkeleton /> : payLater.formattedConvertedAmount}
          </dd>
        </dl>
      )}
    </div>
  );
};
